<style lang="postcss">
	h1 {
		font-size: 2.3rem;
		line-height: 1.3;
		margin: 0;
		margin-top: 1.25rem;
		font-weight: 700;
		letter-spacing: -0.2px;
		text-wrap: balance;
	}
	b {
		font-weight: 600;
	}
	:global(p a) {
		text-decoration: underline !important;
	}
	.main-figure.is-light {
		box-shadow:
			0 0 0 0.5px rgba(0, 0, 0, 0.125),
			0 2px 7px rgba(0, 0, 0, 0.08),
			1px 25px 14px -20px rgba(0, 0, 0, 0.04);
	}
	.main-figure.is-dark::after {
		content: "";
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		right: 0;
		border-radius: inherit;
		border: 1px solid rgba(0, 0, 0, 0.25);
		mix-blend-mode: overlay;
		pointer-events: none;
	}
	figure.feature-figure {
		margin: 1rem 0;
	}
	figcaption {
		font-size: 0.85rem;
		margin-top: 0.5rem;
		@apply text-gray-500;
	}
	.list-share li :global(p) {
		display: inline-block;
		margin: 0;
	}
	.list-workflows li :global(p),
	.list-use-cases li :global(p) {
		display: inline;
		margin: 0;
	}
	.list-section {
		list-style: none;
		counter-reset: h3-counter;
	}
	.tips-list {
		list-style: none;
		margin: 0;
		padding: 0;
	}
	.tips-list :global(p) {
		display: inline;
		margin: 0;
	}
	.tips-list li {
		padding: 0.2rem 0;
		padding-inline-start: 2rem;
		position: relative;
	}
	.tips-list li::marker {
		content: "";
		display: none;
	}
	.tips-list li::before {
		content: "";
		display: inline-block;
		content: "";
		width: 1rem;
		height: 1rem;
		border-radius: 100%;
		margin-right: 0.65rem;
		margin-left: -1.65rem;
		vertical-align: middle;
		background-size: 0.55rem;
	}
	.tips-list.tips-yes li::before {
		background-color: transparent;
		background-repeat: no-repeat;
		background-position: center;
		background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3E%3Crect width='256' height='256' fill='none'/%3E%3Cpolyline points='40 144 96 200 224 72' fill='none' stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='38'/%3E%3C/svg%3E");
		background-color: rgb(30, 189, 125);
	}
	.tips-list.tips-no li::before {
		background-color: transparent;
		background-repeat: no-repeat;
		background-position: center;
		background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3E%3Crect width='12' height='12' fill='none'/%3E%3Cline x1='200' y1='56' x2='56' y2='200' stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='38'/%3E%3Cline x1='200' y1='200' x2='56' y2='56' stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='38'/%3E%3C/svg%3E");
		background-color: rgb(255, 108, 116);
	}
	.accent-one,
	.accent-two {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
	}
	.accent-one {
		background-image: linear-gradient(
			-12deg,
			transparent 0%,
			transparent 50%,
			var(--accent) 50%,
			var(--accent) 60%,
			transparent 60%,
			transparent 100%
		);
		background-size: cover;
		opacity: 0.35;
	}
	.accent-two {
		background-image: linear-gradient(
			-12deg,
			transparent 0%,
			transparent 40%,
			var(--accent) 40%,
			var(--accent) 50%,
			transparent 50%,
			transparent 100%
		);
		background-size: cover;
		opacity: 0.2;
	}
	.list-decimal-custom li :global(p) {
		margin: 0;
		display: inline;
	}
	.list-workflows {
		padding-left: 1.8rem;
	}
	.list-workflows li {
		vertical-align: middle;
		list-style: none;
		padding: 0;
	}
	.list-workflows li .img-cover {
		margin: 0;
		display: inline-block;
		vertical-align: middle;
		width: 20px;
		height: 20px;
		margin-top: -4px;
		margin-right: 5px;
		border-radius: 2.5px;
		margin-left: -1.8rem;
		overflow: hidden;
	}
	.list-workflows li .img-cover img {
		margin: 0;
	}
	.list-workflows li .img-cover.is-svg {
		background-color: #222;
		padding: 3px;
	}
	.list-workflows li .img-cover.is-svg img {
		filter: invert(1);
	}
	.list-use-cases {
		padding-left: 1.8rem;
	}
	.list-use-cases li {
		vertical-align: middle;
		list-style: none;
		padding: 0;
	}
	.list-use-cases li .img-cover {
		margin: 0;
		display: inline-block;
		vertical-align: middle;
		width: 20px;
		height: 20px;
		margin-top: -4px;
		margin-right: 5px;
		border-radius: 2.5px;
		margin-left: -1.8rem;
		overflow: hidden;
		padding: 1.5px;
	}
	.list-use-cases li .img-cover img {
		margin: 0;
	}
	@media (max-width: 768px) {
		h1 {
			font-size: 1.65rem;
			letter-spacing: -0.3px;
			line-height: 1.3;
			margin: 0rem;
			margin-top: -2px;
		}
		figure.feature-figure {
			margin: 0.75rem 0;
		}
		figcaption {
			@apply text-gray-500;
		}
	}
</style>

<script lang="ts">
	import { title } from "$lib/helpers/functions";
	import TemplateFeatures from "design/Components/Basic/TemplateFeatures.svelte";
	import TemplateTile from "$lib/Components/Templates/TemplateTile.svelte";
	import { PUBLIC_APP_URL, PUBLIC_SITE_URL } from "$env/static/public";
	import AllFormsAre from "$src/lib/Components/Basic/AllFormsAre.svelte";
	import dayjs from "dayjs";
	import localizedFormat from "dayjs/plugin/localizedFormat";
	import { getLanguages } from "design/data/languages";
	dayjs.extend(localizedFormat);

	export let data;

	let form = data.template!.forms;
	let template: TemplateDisplay = data.template!;
	let imageLoading = false;
	let figureRef: HTMLElement;
	const languages = getLanguages();

	$: form = data.template?.forms;
	$: template = data.template;
	$: displayImage = template.images.main;
	$: mainImage = getMain(displayImage);

	function getLanguagesText(langs: string[]) {
		const format = new Intl.ListFormat("en", {
			style: "long",
			type: "conjunction"
		});
		return format.format(
			langs
				.map((lang) => languages.find((l) => l.value === lang))
				.map((x) => `${x?.emoji} ${x?.label}`)
		);
	}

	function getFieldAlt(
		field: TemplateMeta["features_field_analytics_field"],
		type = "alt"
	) {
		if (!field || !field.type) {
			return "Field analysis report";
		}
		if (field.type === "MultipleChoice") {
			return type === "alt"
				? `Horizontal bar chart showing the distribution of responses for the multiple choice field '${field.label}'`
				: `Field analysis`;
		}
		if (field.type === "Dropdown") {
			return type === "alt"
				? `Horizontal bar chart showing the distribution of responses for the dropdown field '${field.label}'`
				: `Field analysis`;
		}
		if (field.type === "Rating") {
			return type === "alt"
				? `Timeseries chart showing the rating distribution, average rating for each month, and a trend line for the field '${field.label}'`
				: `Timeseries rating analysis`;
		}
		if (field.type === "NPS") {
			return type === "alt"
				? `Timeseries chart showing the NPS distribution, calculated NPS for each month, and a trend line for the field '${field.label}'`
				: `Timeseries NPS analysis`;
		}
		return `Field analysis report for '${form.name}' showing the ${field} field`;
	}

	const urlBase = `${PUBLIC_SITE_URL}/images/templates`;
	function getAlt(page: any) {
		if (form.pages.length === 1) {
			return (
				template.meta.main_image_alt ||
				`'${form.name}' form with various input fields and a submit button`
			);
		}
		if (!page) {
			const contains = template.features.welcome_svg
				? " an illustration,"
				: template.features.welcome_image
					? " an image,"
					: "";
			return (
				template.meta.main_image_alt ||
				`Welcome step of '${form.name}' with${contains} introduction text, and a '${template.features.welcome_button}' button`
			);
		}
		const is_last = form.pages.indexOf(page) === form.pages.length - 1;
		return `'${page.label ?? "Unknown"}' step of '${form.name} with inputs and a ${is_last ? "submit" : "next"} button`;
	}

	const fixedName = (name: string) => {
		const words = ["form", "questionnaire", "survey", "template"];
		if (words.some((word) => name.toLowerCase().endsWith(word))) {
			return name.trim();
		} else {
			return name.trim() + " form";
		}
	};
	function getMain(images: TemplateImage[]) {
		const image = images.reduce((prev, current) =>
			prev.width > current.width ? prev : current
		);
		const page = form.pages.find((page) => page.id === image.key);
		return {
			...image,
			path: image.updated ? `${image.path}?t=${image.updated}` : image.path,
			alt: getAlt(page)
		};
	}
	$: name = fixedName(form.name);
	$: signup = `${PUBLIC_APP_URL}/signup?template=${template.id}`;
	$: relatedTemplates = data.relatedTemplates ?? [];
	$: images = template.images.main;
	$: shadow = images?.[0].lightness > 70 || true;
	$: showFAQHeader = template.meta.faq.find(
		(faq) => faq.question.trim().length > 0 || faq.answer.trim().length > 0
	);
	function getRandom(string: string, possible: string[]) {
		const only_numbers = string.replace(/\D/g, "") || "0";
		const index = parseInt(only_numbers.slice(0, 5)) % possible.length;
		return possible[index];
	}
	$: seo_title = template.seo_title || `${title(form.name)} Template`;
</script>

<svelte:body class="overflow-x-hidden" />
<svelte:head>
	<title>{seo_title}</title>
	<link
		rel="canonical"
		href="{PUBLIC_SITE_URL}/form-templates/{template.slug}" />
	<meta name="description" content="{template.seo_description}" />
	<meta property="og:site_name" content="Formcrafts" />
	<meta property="og:title" content="{title(form.name)} Template" />
	<meta property="og:type" content="website" />
	<meta property="og:description" content="{template.seo_description}" />
	<meta property="og:image" content="{urlBase}/{mainImage.path}" />
	<link
		rel="preload"
		as="image"
		href="{urlBase}/{mainImage.path}"
		fetchpriority="high" />
</svelte:head>

<div
	class="flex flex-col items-start mr-0 flex-nowrap lg:pr-[34rem] w-full template-cover">
	<h1>
		{name}
	</h1>
	<div class="py-4">
		{@html template.description}
	</div>

	<div class="flex gap-2 mt-4 sm:gap-2">
		<a
			class="flex flex-row gap-1 btn md dark"
			href="{template.link}"
			target="_blank"
			rel="nofollow">
			Live preview ↗
		</a>
		<a rel="nofollow" class="flex flex-row gap-1 btn md dark" href="{signup}">
			Use this template →
		</a>
	</div>

	<TemplateFeatures
		class="flex mt-4 -mb-2 lg:flex"
		expand="{true}"
		downloads="{template.downloads}"
		features="{template.features}" />

	<div
		style="max-width: min(100%, 26.5rem);"
		class="flex flex-col relative gap-2 lg:absolute mt-6 lg:mt-6 w-full lg:w-[26.5rem] lg:top-4 lg:right-0">
		<figure
			itemscope
			bind:this="{figureRef}"
			itemtype="https://schema.org/WebPage"
			class:is-light="{shadow}"
			class:is-dark="{!shadow}"
			class="main-figure relative rounded-md lg:w-auto lg:overflow-y-auto lg:max-h-[70vh]"
			style="max-width: min(100%, 30rem)">
			<div
				class="absolute top-0 bottom-0 left-0 right-0 overflow-hidden md:hidden -mx-base lg:overflow-visible">
				<div class="accent-one" style="--accent: {data.accent}"></div>
				<div class="accent-two" style="--accent: {data.accent}"></div>
			</div>
			<a href="{template.link}" target="_blank" rel="nofollow">
				{#if imageLoading}
					<div
						class="absolute top-0 bottom-0 left-0 right-0 z-10 flex items-center justify-center bg-white bg-opacity-25 rounded-md">
						<div class="loader size-6"></div>
					</div>
				{/if}
				{#key mainImage.path}
					<img
						itemprop="primaryImageOfPage"
						src="{urlBase}/{mainImage.path}"
						width="{mainImage.width}"
						height="{mainImage.height}"
						on:load="{() => {
							imageLoading = false;
						}}"
						alt="{mainImage.alt}"
						class="relative bg-white rounded-md blend-border" />
				{/key}
			</a>
		</figure>
		<AllFormsAre class="hidden w-full mt-8 lg:flex" />
	</div>

	<div class="max-w-full mt-12 prose md:mt-24">
		{@html template.body}

		{#if template.meta.features_multi_show}
			<h2>
				{template.meta.features_multi_glance}
			</h2>
			{@html template.meta.features_multi_description}
			{#if template.meta.features_multi_type === "multi-step"}
				<ol class="list-decimal-custom">
					{#each template.meta.features_multi.filter((x) => x.heading) as feature}
						<li>
							<b>{@html feature.heading}:</b>
							{#if feature.content}{@html feature.content}{/if}
						</li>
					{/each}
				</ol>
			{/if}
		{/if}

		{#if template.meta.features_use_cases_show}
			<h2>
				{template.meta.features_use_cases_glance}
			</h2>
			{@html template.meta.features_use_cases_description}
			<ol class="list-use-cases">
				{#each template.meta.features_use_cases as feature}
					<li>
						{#if feature.icon}
							<div
								class="img-cover"
								style="background: {feature.color || '#666'}">
								<img
									width="32"
									height="32"
									alt="{feature.heading} SVG illustration"
									loading="lazy"
									src="{PUBLIC_APP_URL}/images/svg/{feature.icon.content}" />
							</div>
						{/if}
						<b>{@html feature.heading}:</b>
						{#if feature.content}{@html feature.content}{/if}
					</li>
				{/each}
			</ol>
		{/if}

		{#if template.meta.features_tips_show}
			<h2>
				{template.meta.features_tips_glance}
			</h2>
			<ol
				class="tips-list tips-yes"
				style="--list-color: #3a8e6a; --list-image: url({PUBLIC_APP_URL}/images/svg/ph-thumbs-up-light.svg)">
				{#each template.meta.features_tips_yes.filter(Boolean) as yes}
					<li>{@html yes}</li>
				{/each}
			</ol>
			<ol
				class="tips-list tips-no"
				style="--list-color: #ec5c64; --list-image: url({PUBLIC_APP_URL}/images/svg/ph-thumbs-down-light.svg)">
				{#each template.meta.features_tips_no.filter(Boolean) as no}
					<li>{@html no}</li>
				{/each}
			</ol>
		{/if}

		{#if template.meta.features_logic_show}
			<h2>
				{template.meta.features_logic_glance}
			</h2>
			{@html template.meta.features_logic_description}
		{/if}

		{#if template.meta.features_languages_show}
			<h2>
				{template.meta.features_languages_glance}
			</h2>
			{@html template.meta.features_languages_description}
			<p>
				{getRandom(template.id, [
					"This template is available in",
					"Pre-translated into",
					"This form includes translations for"
				])}
				{getLanguagesText(template.features.languages)}
			</p>
		{/if}

		{#if template.meta.features_share_show}
			<h2>
				{template.meta.features_share_glance}
			</h2>
			{@html template.meta.features_share_description}
			<ol class="list-share">
				{#if template.meta.features_share_link}
					<li>
						<b>Unique link:</b>
						{@html template.meta.features_share_link}
					</li>
				{/if}
				{#if template.meta.features_share_embed}
					<li>
						<b>Seamless embed:</b>
						{@html template.meta.features_share_embed}
					</li>
				{/if}
				{#if template.meta.features_share_library}
					<li>
						<b>Advanced embed:</b>
						{@html template.meta.features_share_library}
					</li>
				{/if}
				{#if template.meta.features_share_email}
					<li>
						<b>Email embed:</b>
						{@html template.meta.features_share_email}
						{#if template.meta.features_share_email_image}
							<figure class="feature-figure">
								<img
									class="max-w-md w-full p-0.5 sm:p-2 bg-white rounded shadow-image"
									loading="lazy"
									alt="Mockup of a gmail email with an embedded '{template.meta
										.features_share_email_image.meta?.label ?? 'form'}' field"
									width="{template.meta.features_share_email_image.width}"
									height="{template.meta.features_share_email_image.height}"
									src="{urlBase}/{template.meta.features_share_email_image
										.path}" />
							</figure>
						{/if}
					</li>
				{/if}
			</ol>
		{/if}
		{#if template.meta.features_workflows_show && template.meta.features_workflows_items.length > 0}
			<h2>
				{template.meta.features_workflows_glance}
			</h2>
			{@html template.meta.features_workflows_description}
			<ul class="list-workflows">
				{#each template.meta.features_workflows_items as item}
					<li>
						<div
							class="img-cover {item.type.icon.includes('svg')
								? 'is-svg'
								: 'is-png'}">
							<img
								src="/images/{item.type.icon.replace(
									'providers',
									'providers-sm'
								)}"
								alt="{item.type.label} icon"
								loading="lazy"
								width="64"
								height="64" />
						</div>
						<b>{item.type.label}:</b>
						{@html item.description}
					</li>
				{/each}
			</ul>
		{/if}
		{#if template.meta.features_partial_show}
			<h2>
				{template.meta.features_partial_glance}
			</h2>
			{@html template.meta.features_partial_description}
		{/if}
		{#if template.meta.features_save_show}
			<h2>
				{template.meta.features_save_glance}
			</h2>
			{@html template.meta.features_save_description}
		{/if}
		{#if template.meta.features_uploads_show}
			<h2>
				{template.meta.features_uploads_glance}
			</h2>
			{@html template.meta.features_uploads_description}
		{/if}
		{#if template.meta.features_math_show}
			<h2>
				{template.meta.features_math_glance}
			</h2>
			{@html template.meta.features_math_description}
		{/if}
		{#if template.meta.features_field_analytics_show && template.meta.features_field_analytics_image && template.meta.features_field_analytics_field}
			<h2>
				{template.meta.features_field_analytics_glance}
			</h2>
			{@html template.meta.features_field_analytics_description}
			<figure class="feature-figure">
				<img
					class="max-w-md w-full p-0.5 sm:p-2 bg-white rounded shadow-image"
					loading="lazy"
					alt="{getFieldAlt(
						template.meta.features_field_analytics_field,
						'alt'
					)}"
					width="{template.meta.features_field_analytics_image.width}"
					height="{template.meta.features_field_analytics_image.height}"
					src="{urlBase}/{template.meta.features_field_analytics_image.path}" />
				<figcaption>
					{getFieldAlt(template.meta.features_field_analytics_field, "caption")}
				</figcaption>
			</figure>
		{/if}
		{#if template.meta.features_field_engagement_show}
			<h2>
				{template.meta.features_field_engagement_glance}
			</h2>
			{@html template.meta.features_field_engagement_description}
			{#if template.meta.features_field_engagement_image}
				<figure class="feature-figure">
					<img
						class="max-w-md w-full p-0.5 sm:p-2 bg-white rounded shadow-image"
						loading="lazy"
						alt="Engagement analysis for '{form.name}' showing the time spent on each form input field, and the drop-off rate"
						width="{template.meta.features_field_engagement_image?.width}"
						height="{template.meta.features_field_engagement_image?.height}"
						src="{urlBase}/{template.meta.features_field_engagement_image
							?.path}" />
					<figcaption>Field engagement and drop-off analysis</figcaption>
				</figure>
			{/if}
		{/if}
		{#if template.meta.features_step_engagement_show && template.meta.features_step_engagement_image}
			<h2>
				{template.meta.features_step_engagement_glance}
			</h2>
			{@html template.meta.features_step_engagement_description}
			{#if template.meta.features_step_engagement_image}
				<figure class="feature-figure">
					<img
						class="max-w-md w-full p-0.5 sm:p-2 bg-white rounded shadow-image"
						loading="lazy"
						alt="Engagement analysis for '{form.name}' showing the time spent on each form step, and the drop-off rate"
						width="{template.meta.features_step_engagement_image.width}"
						height="{template.meta.features_step_engagement_image.height}"
						src="{urlBase}/{template.meta.features_step_engagement_image
							.path}" />
					<figcaption>Step engagement and drop-off analysis</figcaption>
				</figure>
			{/if}
		{/if}
		{#if template.meta.features_before.length > 0}
			{#each template.meta.features_before as feature}
				<h2>{@html feature.heading}</h2>
				{@html feature.content}
			{/each}
		{/if}
		{#if template.meta.integrations.heading}
			<h2>
				{template.meta.integrations.heading}
			</h2>
			{@html template.meta.integrations.content}
			<div
				class="flex flex-row items-center gap-1 text-xs italic text-gray-500">
				<a href="/salesforce-forms">
					<img
						class="rounded-md size-8 rotate-1"
						width="512"
						height="512"
						loading="lazy"
						src="/images/external/salesforce.png"
						alt="Salesforce logo" />
				</a>
				<a href="/hubspot-forms">
					<img
						class="rounded-md size-8 -rotate-1"
						width="512"
						height="512"
						loading="lazy"
						src="/images/external/hubspot.png"
						alt="HubSpot logo" />
				</a>
				<a href="/zendesk-ticket-forms">
					<img
						class="rounded-md size-8 rotate-1"
						width="512"
						height="512"
						loading="lazy"
						src="/images/external/zendesk.png"
						alt="Zendesk logo" />
				</a>
				<span class="pl-2"> and many more</span>
			</div>
		{/if}

		{#if showFAQHeader}
			<h2>
				{getRandom(template.id, [
					"Frequently asked questions",
					"Common questions",
					"Questions and answers"
				])}
			</h2>
			<div class="list-section">
				{#each template.meta.faq as faq}
					<div class="mt-12">
						{#if faq.question.trim().length > 0 || faq.answer.trim().length > 0}
							<p>
								<span class="text-base font-semibold"
									>{@html faq.question}</span>
							</p>
							{@html faq.answer.includes("<p>")
								? faq.answer
								: `<p>${faq.answer}</p>`}
						{/if}
					</div>
				{/each}
			</div>
		{/if}

		{#if relatedTemplates && relatedTemplates.length > 0}
			<h2>Related templates</h2>
			<div class="grid grid-cols-2 gap-3 sm:grid-cols-4">
				{#each relatedTemplates as template}
					<TemplateTile eager="{false}" data="{template}" />
				{/each}
			</div>
		{/if}
	</div>

	<div class="w-full">
		<AllFormsAre class="flex w-full mt-12 lg:hidden" />
	</div>
</div>
